import { GroupBase, StylesConfig } from 'react-select'

export const MAX_OPTIONS_MENU_WIDTH = 450 // px

export const styles = <
  Option,
  isMulti extends boolean,
  Group extends GroupBase<Option>,
>({
  optionsPosition,
  isInsideTable,
  isCreatable,
  isMinimized,
}: {
  optionsPosition: 'left' | 'right'
  isInsideTable?: boolean
  isCreatable?: boolean
  isMinimized?: boolean
  isDisabled?: boolean
}): StylesConfig<Option, isMulti, Group> => {
  return {
    menuPortal: (defaultStyles) => ({
      ...defaultStyles,
      zIndex: 9999,
    }),
    container: (defaultStyles, state) => ({
      ...defaultStyles,
      height: isInsideTable ? '100%' : 'auto',
    }),
    control: (defaultStyles, state) => {
      return {
        ...defaultStyles,
        width: '100%',
        height: isInsideTable ? '100%' : 40,
        flexWrap: 'nowrap',
        ...(isInsideTable ? { border: 'none !important' } : {}),
        borderColor: state.isFocused ? '#15020c' : '#e0c797',
        borderRadius: '2px',
        backgroundColor: isInsideTable ? 'transparent' : '#fffdf9',
        ...(state.isDisabled
          ? {
              cursor: 'not-allowed',
              pointerEvents: 'auto',
              opacity: 0.4,
            }
          : { cursor: 'pointer' }),
        boxShadow:
          state.isFocused && !isInsideTable ? '0 2px 4px 0 #a89163' : 'none',

        '&:hover': {
          borderColor: state.isDisabled ? '#e0c797' : '#a89163',
        },
      }
    },
    placeholder: (defaultStyles, state) => {
      const size = state.selectProps['size']
      return {
        ...defaultStyles,
        color: state.isFocused ? '#15020c' : '#605030',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        ...(size === 'large' && { fontSize: '16px' }),
      }
    },
    clearIndicator: (defaultStyles, state) => {
      const display =
        state.selectProps.isClearable && state.selectProps.value
          ? 'block'
          : 'none'
      return {
        ...defaultStyles,
        display,
      }
    },
    indicatorSeparator: () => {
      return {
        display: 'none',
      }
    },
    dropdownIndicator: (defaultStyles, state) => {
      const display =
        state.selectProps.isClearable && state.selectProps.value
          ? 'none'
          : 'block'
      return {
        ...defaultStyles,
        display,
        color: state.isFocused && !isInsideTable ? '#15020c' : '#605030',
        '&:hover': { color: state.isDisabled ? '#605030' : '#15020c' },
      }
    },
    menu: (defaultStyles) => {
      const position = optionsPosition === 'right' ? { right: 0 } : {}
      return {
        ...defaultStyles,
        margin: 0,
        width: 'max-content',
        minWidth: '100%',
        display: 'inline-block',
        border: '1px solid #e4e4e7',
        boxShadow: `0 4px 6px -2px rgba(0, 0, 0, 0.05), 
      0 10px 15px -3px rgba(0, 0, 0, 0.1)`,
        ...position,
        maxWidth: MAX_OPTIONS_MENU_WIDTH,
        zIndex: 9999,
      }
    },
    option: () => {
      return {}
    },
    valueContainer: (defaultStyles, state) => {
      const { size } = state.selectProps

      return {
        ...defaultStyles,
        height: '100%',
        color: '#1f2937',
        ...(isInsideTable ? { paddingLeft: 0 } : {}),
        fontWeight: 500,
        padding: isCreatable ? '0.5rem' : '0.5rem 0.75rem',
        transition: '0.7s padding',
        ...(isMinimized ? { padding: 0 } : {}),
        ...(size === 'large' && { fontSize: '16px' }),
      }
    },
    singleValue: (defaultStyles) => {
      return {
        ...defaultStyles,
        whiteSpace: 'pre-line',
      }
    },
    multiValue: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: '#ffffff',
        backgroundColor: '#901356',
        borderRadius: '4px',
        margin: '0 8px 0 0',
        zIndex: 9999,
      }
    },
    multiValueLabel: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: '#ffffff',
      }
    },
    multiValueRemove: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: '#af6693',
        '&:hover': {
          color: '#ffffff',
          backgroundColor: '#901356',
        },
      }
    },
    input: (defaultStyles) => {
      return {
        ...defaultStyles,
        margin: 0,
        padding: 0,
      }
    },
  }
}
